import React, { useEffect } from 'react';
import { CaptureOverlay } from '../shared';
import { safeExitPiP } from '../../../../utils/mediaUtils';

interface GuidedLaunchedProps {
  taskName: string;
  onUpload: () => void;
  onClose: () => void;
}

export const GuidedLaunched: React.FC<GuidedLaunchedProps> = ({
  taskName,
  onUpload,
  onClose,
}) => {
  // Fix 3: visibilitychange listener — detect user returning from recording
  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        safeExitPiP();
        onUpload();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, [onUpload]);

  return (
    <CaptureOverlay taskName={taskName} onClose={onClose}>
      <div className="gc-launched-body">
        <div className="gc-app-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#D4715A" strokeWidth="1.5" strokeLinecap="round">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
          </svg>
        </div>
        <div>
          <div className="gc-launched-title">Recording your screen</div>
          <div className="gc-launched-desc">
            Navigate naturally in the app. When you're done, stop the recording and return to Dekko.
          </div>
        </div>
        <div className="gc-launched-tip">
          Stop recording via the <span className="gc-tip-ember">red status bar</span> at the top of your screen
        </div>
        <div className="gc-waiting-text">Waiting for you to return…</div>
      </div>

      <div className="gc-bottom-simple">
        <button className="gc-btn-disabled">Review &amp; Submit</button>
        <div className="gc-btn-hint">Enabled after you upload a recording</div>
      </div>
    </CaptureOverlay>
  );
};
